enum JobCategory {
  MECHANIC,
  CHECKLIST,
  QUOTE,
  BOOKING_ITEM,
  OTHER
}

export default JobCategory;